import {
  Flex,
  Grid,
  HStack,
  IconButton,
  Skeleton,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiDeleteBinLine, RiEditBoxLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { openCreateGroup } from "../../../modules/admin-modules/models/Actions";
import { deleteGroupRequest } from "../../../modules/superadmin-modules/groups/Actions";

const GroupsTable = ({ setAdd, setSelectedData }) => {
  const { groups, isLoading } = useSelector((state) => state.superadminGroups);
  const dispatch = useDispatch();

  return (
    <Grid
      templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
      gap={6}
      my={5}
      minH={groups?.length == 0 && "200px"}
    >
      {isLoading ? (
        <Skeleton>
          <div>contents wrapped</div>
          <div>won't be visible</div>
        </Skeleton>
      ) : (
        groups.map((group, index) => {
          return (
            <VStack
              key={index}
              spacing={4}
              align="stretch"
              border="1px solid"
              borderColor="main_1"
              borderRadius="8px"
              p="10px"
              fontSize="18px"
            >
              <HStack justifyContent="space-between">
                <Flex>
                  <Text> مجموعة : </Text>
                  <Text opacity="0.6">{group?.name}</Text>
                </Flex>
                <HStack>
                  <IconButton
                    icon={<RiEditBoxLine />}
                    variant="outline"
                    title="تعديل"
                    onClick={() => {
                      setSelectedData({
                        ...group,
                        subject_id: group?.subject?.id,
                      });

                      setAdd(false);
                      dispatch(openCreateGroup());
                    }}
                  />
                  <IconButton
                    icon={<RiDeleteBinLine color="red" />}
                    variant="outline"
                    onClick={() => dispatch(deleteGroupRequest(group?.id))}
                  />
                </HStack>
              </HStack>
              <HStack justifyContent="space-between">
                <Flex>
                  <Text> ID : </Text>
                  <Text opacity="0.6">{group?.id}</Text>
                </Flex>
              </HStack>
              <HStack justifyContent="space-between">
                <Flex>
                  <Text> السنة الدراسية : </Text>
                  <Text opacity="0.6">{group?.course?.name}</Text>
                </Flex>
              </HStack>
            </VStack>
          );
        })
      )}
    </Grid>
  );
};

export default GroupsTable;
